import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, Button, Form } from "react-bootstrap";
import { get } from "lodash";
import { isValidArray } from "../../../helper";

class UploadErrorModalComponent extends Component {
  render() {
    const { show, closeModal, uploadedList, addInAgenda } = this.props;
    const noErrorLists =
      !isValidArray(uploadedList.invalidProjectIds) &&
      !isValidArray(uploadedList.invalidIssueIds) &&
      !isValidArray(uploadedList.duplicateProjectIds) &&
      !isValidArray(uploadedList.duplicateProjectIds) &&
      !isValidArray(uploadedList.issueIdsWithOutProjectId) &&
      !isValidArray(uploadedList.alreadyAddedProjectIds) &&
      !isValidArray(uploadedList.alreadyAddedIssueIds);

    return (
      <React.Fragment>
        <Modal
          show={show}
          dialogClassName="uploadErrorModal"
          onHide={closeModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Invalid Data</Modal.Title>
          </Modal.Header>

          <Modal.Body className="scroll">
            <div className="alert-header">
              <span className="alert-icon">!</span>
              <span className="alert-title">Errors and Alerts Found</span>
            </div>
            <div className="alert-body">
              {noErrorLists ? (
                <p className="error-text">{uploadedList.message}</p>
              ) : (
                <ol className="error-list">
                  {uploadedList.invalidProjectIds &&
                    uploadedList.invalidProjectIds.length > 0 && (
                      <li>
                        Invalid Project ID(s):{" "}
                        {uploadedList.invalidProjectIds
                          .map(id => `#${id}`)
                          .join(", ")}
                      </li>
                    )}
                  {uploadedList.invalidIssueIds &&
                    uploadedList.invalidIssueIds.length > 0 && (
                      <li>
                        Invalid Issue ID(s):{" "}
                        {uploadedList.invalidIssueIds
                          .map(id => `#${id}`)
                          .join(", ")}
                      </li>
                    )}
                  {uploadedList.duplicateProjectIds &&
                    uploadedList.duplicateProjectIds.length > 0 && (
                      <li>
                        Duplicate Project ID(s):{" "}
                        {uploadedList.duplicateProjectIds
                          .map(id => `#${id}`)
                          .join(", ")}
                      </li>
                    )}
                  {uploadedList.duplicateIssueIds &&
                    uploadedList.duplicateIssueIds.length > 0 && (
                      <li>
                        Duplicate Issue ID(s):{" "}
                        {uploadedList.duplicateIssueIds
                          .map(id => `#${id}`)
                          .join(", ")}
                      </li>
                    )}
                  {uploadedList.issueIdsWithOutProjectId &&
                    uploadedList.issueIdsWithOutProjectId.length > 0 && (
                      <li>
                        Issue(s) missing Project ID:{" "}
                        {uploadedList.issueIdsWithOutProjectId
                          .map(id => `#${id}`)
                          .join(", ")}
                      </li>
                    )}
                  {uploadedList.alreadyAddedProjectIds &&
                    uploadedList.alreadyAddedProjectIds.length > 0 && (
                      <li>
                        Project(s) Already Added:{" "}
                        {uploadedList.alreadyAddedProjectIds
                          .map(id => `#${id}`)
                          .join(", ")}
                      </li>
                    )}

                  {uploadedList.alreadyAddedIssueIds &&
                    uploadedList.alreadyAddedIssueIds.length > 0 && (
                      <li>
                        Issue(s) Already Added:{" "}
                        {uploadedList.alreadyAddedIssueIds
                          .map(id => `#${id}`)
                          .join(", ")}
                      </li>
                    )}
                </ol>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    uploadedList: state.donwloadExcelReducer.uploadProjectIssues.uploadedList
  };
}

const UploadErrorModal = connect(
  mapStateToProps
  // mapDispatchToProps
)(UploadErrorModalComponent);
export { UploadErrorModal };
